var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_info",
    "data-name": "icon / info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.09,
    viewBox: "0 0 18 18.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M41.6,3.7A8.639,8.639,0,0,1,47.99,1a8.3,8.3,0,0,1,6.3,2.7,8.556,8.556,0,0,1,2.61,6.39,8.908,8.908,0,0,1-2.61,6.39,8.556,8.556,0,0,1-6.39,2.61,8.908,8.908,0,0,1-6.39-2.61,8.556,8.556,0,0,1-2.61-6.39A9.212,9.212,0,0,1,41.6,3.7Zm1.26,11.43a6.957,6.957,0,0,0,5.04,2.16,6.811,6.811,0,0,0,5.04-2.16,6.957,6.957,0,0,0,2.16-5.04,6.671,6.671,0,0,0-2.16-5.04A6.4,6.4,0,0,0,47.99,2.8a6.811,6.811,0,0,0-5.04,2.16A6.957,6.957,0,0,0,40.79,10,6.6,6.6,0,0,0,42.86,15.13ZM47.09,5.5h1.8v5.4h-1.8Zm0,7.2h1.8v1.8h-1.8Z",
    transform: "translate(56.9 19.09) rotate(180)",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconblue);
export default __webpack_public_path__ + "static/media/InfoIconblue.072df031f53610208fdd629dac0e31d6.svg";
export { ForwardRef as ReactComponent };